// extracted by mini-css-extract-plugin
module.exports = {"listElement":"CardElement_listElement__1l-KI"};